<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from "../../../../../layouts/nav/SNB.vue";
import UserMatchingResumeProposalListView from "../userResume/UserMatchingResumeProposalListView.vue";
import UserProposalUserView from "../userResume/UserProposalUserView.vue";
import UserMatchingResumeApplyListView from "@/pages/user/views/mypage/userResume/UserMatchingResumeApplyListView.vue";

const route = useRoute();
const router = useRouter();
const tabRef = ref(null);

const snbKey = ref(0);

const tabOptions = [
  { label: '인재정보 등록 현황', value: 'userResume' },
  { label: '입사지원 현황', value: 'userResumeApply' },
  { label: '받은 채용제안', value: 'userProposal' },
];

const getTabValue = (tab) => {
  return tabOptions.some(option => option.value === tab) ? tab : tabOptions[0].value;
}

const selectedTabValue = ref(getTabValue(route.query.tab));

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;

  if (tabRef.value) {
    tabRef.value.init(tab.value);
  }

  if (selectedTabValue.value === tab.value) {
    return;
  }

  router.push({ query: { ...route.query, tab: tab.value } });
};

onMounted(() => {
  const tabFromQuery = route.query.tab;
  if (tabFromQuery && tabOptions.some(option => option.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  }
});
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB :key="snbKey" class="snb" />
        <div class="content">
          <div class="sub-title">
            <h3>상시채용관 현황</h3>
          </div>
          <div class="tab-wrap mb-sm">
            <KSATab
                ref="tabRef"
                :options="tabOptions"
                @change="onChangeTab"
                style="grid-template-columns: repeat(3, 1fr);"
            />
          </div>
          <div v-if="selectedTabValue === 'userResume'">
            <UserMatchingResumeProposalListView />
          </div>
          <div v-if="selectedTabValue === 'userResumeApply'">
            <UserMatchingResumeApplyListView />
          </div>
          <div v-else-if="selectedTabValue === 'userProposal'">
            <UserProposalUserView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>
